var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9809 21.3928C39.9809 19.6721 39.8448 18.4164 39.5503 17.1143H20.3984V24.8807H31.6402C31.4136 26.8108 30.1897 29.7175 27.4698 31.6706L27.4317 31.9306L33.4872 36.7435L33.9067 36.7864C37.7597 33.1357 39.9809 27.7641 39.9809 21.3928Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3984 41.8557C25.9059 41.8557 30.5295 39.9953 33.9067 36.7865L27.4698 31.6707C25.7473 32.9031 23.4355 33.7635 20.3984 33.7635C15.0042 33.7635 10.4259 30.1128 8.79391 25.0669L8.55469 25.0877L2.25812 30.0872L2.17578 30.322C5.53016 37.1584 12.4203 41.8557 20.3984 41.8557Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79391 25.0669C8.36328 23.7647 8.11406 22.3694 8.11406 20.9278C8.11406 19.486 8.36328 18.0909 8.77125 16.7887L8.75984 16.5114L2.38437 11.4316L2.17578 11.5334C0.793281 14.3704 0 17.5561 0 20.9278C0 24.2995 0.793281 27.4851 2.17578 30.322L8.79391 25.0669Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3984 8.09205C24.2288 8.09205 26.8125 9.78953 28.2858 11.2081L34.0427 5.44124C30.507 2.06954 25.9059 0 20.3984 0C12.4203 0 5.53016 4.69711 2.17578 11.5335L8.77125 16.7888C10.4259 11.7428 15.0042 8.09205 20.3984 8.09205Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleIcon);
export default __webpack_public_path__ + "static/media/logos_google-icon.18103ff3b1109b10154c24492b033886.svg";
export { ForwardRef as ReactComponent };